<du-config-overview [overviewModel]="translationOverviewModel"></du-config-overview>
